export const POLICY_SERVARIANISM_UNIT_BONUS_SIZE_THRESHOLD = 7;
export const POLICY_SERVARIANISM_UNIT_BONUS_COINS_INCOME = 1;

export const POLICY_SERVARIANISM_BARRACKS_BONUS_COINS_INCOME = 1;

